import React from 'react';
import PropTypes from 'prop-types';

import ExpandMoreArrowDown from '../../../common/img/components/ExpandMoreArrowDown';
import ExpandMoreArrowUp from '../../../common/img/components/ExpandMoreArrowUp';

const ExpandAccordionButton = ({
  showBelowFold,
  setShowBelowFold,
}) => {
  const handleClick = () => setShowBelowFold((prevState) => !prevState);

  return (
    <div className="expand-button-wrapper">
      <button onClick={handleClick} type="button">
        <div className="expand-button">
          <span className="expand-button__text">View all publications</span>
          {showBelowFold ? <ExpandMoreArrowUp /> : <ExpandMoreArrowDown /> }
        </div>
      </button>
    </div>
  );
};

ExpandAccordionButton.propTypes = {
  showBelowFold: PropTypes.bool.isRequired,
  setShowBelowFold: PropTypes.func.isRequired,
};

export default ExpandAccordionButton;
